/**
 * POST `admin/clients/:id/subscription/activate` — отметить оплату подписки.
 * Провайдер перевод на счёт не видит — оплату отмечает команда Skrezo;
 * доступ открывается сразу до `paidUntil`. Повторная активация снимает
 * и блокировку. Мок: статус «Активна» и новая дата продления.
 */

import dayjs from 'dayjs';

import {apiEnabled, http} from '@services/utils';

import {MOCK_CLIENTS} from '../mocks';
import type {SubscriptionStatus} from '../types';

export type ActivateSubscriptionInput = {
  id: string;
  /** Последний оплаченный день, YYYY-MM-DD: доступ закроется в конце этого дня */
  paidUntil: string;
};

/** Состояние подписки после действия команды (AdminSubscriptionResponse) */
export type AdminSubscription = {
  status: SubscriptionStatus;
  currentPeriodEnd: string | null;
  /** Клиника в режиме чтения прямо сейчас */
  writesBlocked: boolean;
};

const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));

export const toAdminSubscription = (raw: unknown): AdminSubscription => {
  const r = (typeof raw === 'object' && raw !== null ? raw : {}) as Record<string, unknown>;
  return {
    status: typeof r.status === 'string' ? (r.status as SubscriptionStatus) : 'active',
    currentPeriodEnd: typeof r.currentPeriodEnd === 'string' ? r.currentPeriodEnd : null,
    writesBlocked: r.writesBlocked === true,
  };
};

export const activateSubscription = async (
  input: ActivateSubscriptionInput,
): Promise<AdminSubscription> => {
  const paidUntil = dayjs(input.paidUntil).endOf('day').toISOString();
  if (!apiEnabled) {
    await sleep(400);
    const row = MOCK_CLIENTS.find((c) => c.id === input.id);
    if (row) {
      row.subscriptionStatus = 'active';
      row.currentPeriodEnd = paidUntil;
      row.trialDay = null;
    }
    return {status: 'active', currentPeriodEnd: paidUntil, writesBlocked: false};
  }
  return toAdminSubscription(
    await http(`admin/clients/${encodeURIComponent(input.id)}/subscription/activate`, {
      method: 'POST',
      body: {paidUntil},
      skipCaseConversion: true,
    }),
  );
};
